/* ============================================================
   SK Intake — 3-step custom-meal-prep form behaviour.
   - step nav + progress
   - coach-plan path toggle (upload  vs  type your macros)
   - file dropzone (PDF / JPG / PNG, client-side list + size guard)
   - per-step required-field validation
   - submit: POSTs multipart/form-data to data-endpoint (n8n webhook)
     when set; otherwise just shows the confirmation panel (preview).
   No external libs. Honours prefers-reduced-motion via CSS.
   ============================================================ */
(function () {
  function init(root) {
    if (root.dataset.skIntakeReady) return;
    root.dataset.skIntakeReady = '1';

    var form     = root.querySelector('[data-intake-form]');
    if (!form) return;
    var panels   = Array.prototype.slice.call(form.querySelectorAll('.panel'));
    var stepEls  = Array.prototype.slice.call(root.querySelectorAll('.steps .st'));
    var doneEl   = form.querySelector('.done');
    var errEl    = form.querySelector('.err');
    var MAX_MB   = parseFloat(root.dataset.maxMb || '10');
    var MAX_TOTAL_MB = parseFloat(root.dataset.maxTotalMb || '20');   // email attachments cap out near 25MB
    var endpoint = (root.dataset.endpoint || '').trim();
    var current  = 0;

    /* ---- session memory (retain progress + round-trip with the calculator) ---- */
    var SS = (function () { try { return window.sessionStorage; } catch (e) { return null; } })();
    var K_STATE = 'sk:intake', K_RETURN = 'sk:intake-return', K_CALC = 'sk:calc';
    function ssGet(k) { try { return SS && SS.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { SS && SS.setItem(k, v); } catch (e) {} }
    function ssDel(k) { try { SS && SS.removeItem(k); } catch (e) {} }

    function snapshot() {
      if (!SS) return;
      var checked = form.querySelector('input[name="plan_path"]:checked');
      var data = { step: current, path: checked ? checked.value : '', vals: {} };
      form.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (el) {
        if (el.type === 'file' || el.name === 'plan_path') return;
        if (el.type === 'checkbox' || el.type === 'radio') {
          data.vals[el.name] = data.vals[el.name] || [];          // an empty list = deliberately unticked
          if (el.checked) data.vals[el.name].push(el.value);
        } else if (el.value !== '') { data.vals[el.name] = el.value; }
      });
      ssSet(K_STATE, JSON.stringify(data));
    }
    var snapT;
    function snapSoon() { clearTimeout(snapT); snapT = setTimeout(snapshot, 250); }

    function applyVals(vals) {
      Object.keys(vals || {}).forEach(function (name) {
        var v = vals[name];
        form.querySelectorAll('[name="' + name + '"]').forEach(function (el) {
          if (el.type === 'checkbox' || el.type === 'radio') {
            el.checked = Array.isArray(v) ? v.indexOf(el.value) > -1 : (el.value === v);
          } else { el.value = v; }
        });
      });
    }
    function setPath(val) {
      var r = form.querySelector('input[name="plan_path"][value="' + val + '"]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    function restore() {
      var startStep = 0, hadState = false;
      var raw = ssGet(K_STATE);
      if (raw) {
        try { var d = JSON.parse(raw); hadState = true; applyVals(d.vals); if (d.path) setPath(d.path); startStep = d.step || 0; } catch (e) {}
      }
      // numbers returned from the calculator → drop into the macro fields (Step 2)
      var calcRaw = ssGet(K_CALC);
      if (calcRaw) {
        try {
          var c = JSON.parse(calcRaw);
          var set = function (n, val) { var el = form.querySelector('[name="' + n + '"]'); if (el && val != null) el.value = val; };
          set('Calories', c.cal); set('Protein', c.p); set('Carbs', c.c); set('Fat', c.f);
          setPath('macros');
          // NOTE: we do NOT jump past Step 1. Arriving fresh from the calculator still
          // needs "About you" (name/email/goal), so we start there with the numbers
          // saved and waiting in Step 2. A returning custom-plan user keeps their own step.
          var note = form.querySelector('[data-calc-note]');
          if (note) note.hidden = false;
          ssDel(K_CALC);                           // consume once, so later edits aren't clobbered
        } catch (e) {}
      }
      return startStep;
    }

    /* ---- step display ---- */
    function show(i) {
      current = Math.max(0, Math.min(i, panels.length - 1));
      panels.forEach(function (p, idx) { p.classList.toggle('is-on', idx === current); });
      stepEls.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
        s.classList.toggle('is-done', idx < current);
      });
      if (errEl) errEl.classList.remove('is-on');
      snapshot();
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { root.scrollIntoView(); }
    }

    /* ---- validation for the current step ---- */
    function validateStep() {
      var panel = panels[current];
      var missing = [];
      panel.querySelectorAll('input[required], textarea[required], select[required]').forEach(function (el) {
        var field = el.closest('.field');
        var ok = el.type === 'email'
          ? /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value.trim())
          : el.value.trim() !== '';
        if (field) field.classList.toggle('has-error', !ok);
        if (!ok) missing.push(el);
      });
      // radio groups marked required via data-require-group
      panel.querySelectorAll('[data-require-group]').forEach(function (grp) {
        var name = grp.getAttribute('data-require-group');
        var checked = form.querySelector('input[name="' + name + '"]:checked');
        if (!checked) missing.push(grp);
      });
      // upload path chosen but no file attached (or the file was lost on a reload)
      var dropHere = panel.querySelector('.drop');
      var pathNow = form.querySelector('input[name="plan_path"]:checked');
      if (dropHere && pathNow && pathNow.value === 'upload' && files.length === 0) {
        var pasted = panel.querySelector('[name="Pasted targets"]');
        if (!(pasted && pasted.value.trim() !== '')) {
          dropHere.classList.add('has-error');
          if (errEl) { errEl.textContent = 'Please attach your coach plan, paste your targets, or choose “I’ll type my macros”.'; errEl.classList.add('is-on'); try { dropHere.focus(); } catch (e) {} }
          return false;
        }
      }
      if (dropHere) dropHere.classList.remove('has-error');
      if (missing.length && errEl) {
        errEl.textContent = errEl.dataset.msg || 'Please fill in the highlighted fields before continuing.';
        errEl.classList.add('is-on');
        try { missing[0].focus(); } catch (e) {}
      }
      return missing.length === 0;
    }

    /* ---- next / back ---- */
    form.addEventListener('click', function (e) {
      var next = e.target.closest('[data-next]');
      var back = e.target.closest('[data-back]');
      if (next) { e.preventDefault(); if (validateStep()) show(current + 1); }
      if (back) { e.preventDefault(); show(current - 1); }
    });

    /* ---- persist progress as they go ---- */
    form.addEventListener('input', snapSoon);
    form.addEventListener('change', snapshot);

    /* ---- hand off to the calculator, remembering where to come back to ---- */
    var calcLink = form.querySelector('[data-calc-link]');
    if (calcLink) calcLink.addEventListener('click', function (e) {
      snapshot();
      ssSet(K_RETURN, location.pathname + location.search + location.hash);
      var href = calcLink.getAttribute('href') || '';
      if (href && href.indexOf('from=custom-plan') === -1) {
        e.preventDefault();
        location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'from=custom-plan';
      }
    });

    /* ---- coach-plan path toggle ---- */
    form.querySelectorAll('input[name="plan_path"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var val = r.value;
        form.querySelectorAll('[data-path]').forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-path') === val);
        });
      });
    });

    /* ---- file dropzone ---- */
    var drop  = form.querySelector('.drop');
    var input = drop && drop.querySelector('input[type=file]');
    var list  = form.querySelector('.filelist');
    var files = [];
    function human(b) { return b < 1024 * 1024 ? Math.round(b / 1024) + ' KB' : (b / 1048576).toFixed(1) + ' MB'; }
    function render() {
      if (!list) return;
      list.innerHTML = '';
      files.forEach(function (f, i) {
        var li = document.createElement('li');
        li.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v5h5"/><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/></svg>'
          + '<span>' + f.name.replace(/[<>&]/g, '') + '</span>'
          + '<span class="fsz">' + human(f.size) + '</span>'
          + '<button type="button" class="rm" data-rm="' + i + '" aria-label="Remove file">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
        list.appendChild(li);
      });
    }
    function totalBytes() { return files.reduce(function (n, f) { return n + f.size; }, 0); }
    function showErr(msg) { if (errEl) { errEl.textContent = msg; errEl.classList.add('is-on'); } }
    function add(fileList) {
      Array.prototype.forEach.call(fileList, function (f) {
        if (f.size === 0) {
          // An empty file breaks the receiving robot for every file after it. Refuse it here.
          showErr('“' + f.name + '” looks empty (0 KB). Please re-save or screenshot your plan and try again.');
          return;
        }
        if (f.size > MAX_MB * 1048576) {
          showErr('“' + f.name + '” is over ' + MAX_MB + 'MB. Please upload a smaller file.');
          return;
        }
        if (totalBytes() + f.size > MAX_TOTAL_MB * 1048576) {
          showErr('That brings your files over ' + MAX_TOTAL_MB + 'MB in total. Please send fewer or smaller files, or email the rest to info@theshreddedkitchen.nz.');
          return;
        }
        files.push(f);
      });
      render();
    }
    if (drop && input) {
      drop.addEventListener('click', function () { input.click(); });
      drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
      input.addEventListener('change', function () { add(input.files); input.value = ''; });
      ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-hover'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-hover'); }); });
      drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); });
      if (list) list.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-rm]');
        if (rm) { files.splice(parseInt(rm.getAttribute('data-rm'), 10), 1); render(); }
      });
    }

    /* ---- analytics ----
       The form sends over fetch, so GA4's automatic form tracking sees form_start
       but never form_submit — the funnel dead-ends and every lead looks lost.
       Fire the events ourselves: generate_lead on a confirmed send, and
       sk_custom_plan_error when the send fails, so a broken endpoint is visible. */
    function fieldVal(name) {
      var el = form.querySelector('[name="' + name + '"]:checked') || form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }
    function track(evName, extra) {
      var payload = {
        form_name: 'custom_plan_intake',
        goal: fieldVal('Goal'),
        plan_path: fieldVal('plan_path'),
        files_attached: files.length
      };
      if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) payload[k] = extra[k]; } }
      try { if (typeof window.gtag === 'function') window.gtag('event', evName, payload); } catch (err) {}
      try {
        window.dataLayer = window.dataLayer || [];
        var dl = { event: 'sk_' + evName };
        for (var j in payload) { if (payload.hasOwnProperty(j)) dl[j] = payload[j]; }
        window.dataLayer.push(dl);
      } catch (err) {}
    }

    /* ---- submit ---- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateStep()) return;

      function succeed() {
        ssDel(K_STATE); ssDel(K_RETURN);   // finished — forget the saved progress
        var cn = form.querySelector('[data-calc-note]'); if (cn) cn.hidden = true;
        panels.forEach(function (p) { p.classList.remove('is-on'); });
        var stepsBar = root.querySelector('.steps');
        if (stepsBar) stepsBar.style.display = 'none';
        if (doneEl) doneEl.classList.add('is-on');
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { root.scrollIntoView(); }
      }

      if (!endpoint) { succeed(); return; }   // preview mode: no endpoint wired yet

      var fd = new FormData(form);
      // The native picker input is emptied after each pick (its files live in `files`),
      // but FormData still serialises it as an empty file part (filename=""). n8n's
      // multipart parser stops collecting files at that empty part, so every real
      // attachment appended after it was silently dropped. Remove it before sending.
      fd.delete('coach_plan_input');
      files.forEach(function (f) { fd.append('coach_plan[]', f, f.name); });
      var btn = form.querySelector('[data-submit]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }
      var sentCount = files.length;
      fetch(endpoint, { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error('status ' + r.status);
          return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} return j; }).catch(function () { return null; });
        })
        .then(function (j) {
          track('generate_lead');            // only ever on a confirmed send
          succeed();
          // The robot reports how many files it actually received. If that is fewer than
          // we sent, say so instead of a silent "sent" (this is how uploads went missing before).
          var warn = form.querySelector('[data-done-warn]');
          if (warn && j && typeof j.received_files === 'number' && j.received_files < sentCount) {
            warn.hidden = false;
            track('custom_plan_file_mismatch', { sent: sentCount, received: j.received_files });
          }
        })
        .catch(function (err) {
          track('custom_plan_error', { error_message: String((err && err.message) || 'network') });
          if (errEl) { errEl.textContent = 'Something went wrong sending your form. Please try again, or email info@theshreddedkitchen.nz.'; errEl.classList.add('is-on'); }
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Send my plan'; }
        });
    });

    show(restore());
  }

  function boot() {
    document.querySelectorAll('.sk-intake').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
